import React from 'react';
import { useTranslation } from 'react-i18next';
import type { CustomerDisplayInfo } from '../../hooks/useCustomerDisplay';

interface Props {
  /** Ο διακόπτης του καταστήματος (store.customer_display_enabled). Κλειστός: δεν εμφανίζεται τίποτα. */
  enabled: boolean;
  selectedId: string;
  select: (id: string) => void;
  displays: CustomerDisplayInfo[];
  refresh: () => void;
  connected: boolean;
  error: string;
}

export default function CustomerDisplaySettings({ enabled, selectedId, select, displays, refresh, connected, error }: Props) {
  const { t } = useTranslation('takeaway');
  if (!enabled) return null;
  return <div className="pt-3 border-t border-line-strong space-y-2">
    <label htmlFor="customer-display" className="block text-t2 text-sm font-medium">{t('vfd.title')}</label>
    <select id="customer-display" value={selectedId} onChange={e => select(e.target.value)} className="w-full p-2 rounded-lg bg-surface-3 text-t1 border border-line-strong">
      <option value="">{t('vfd.disabled')}</option>
      {selectedId && !displays.some(d => d.id === selectedId) && <option value={selectedId}>{selectedId} ({t('vfd.offline')})</option>}
      {displays.map(d => <option key={d.id} value={d.id} disabled={d.conflict}>{d.name} — {d.port}{d.conflict ? ` (${t('vfd.conflict')})` : ''}</option>)}
    </select>
    <button type="button" onClick={refresh} className="text-sm text-blue-600 dark:text-blue-400 underline">{t('vfd.refresh')}</button>
    <p className="text-xs text-t3">{t('vfd.hint')}</p>
    {selectedId && <p role="status" className={`text-xs ${connected ? 'text-green-600' : 'text-amber-600'}`}>{connected ? t('vfd.connected') : error || t('vfd.offline')}</p>}
  </div>;
}
